import React, { useState, useEffect } from "react";
import ThemedSelect from 'components/ThemedSelect';

const DEFAULT_FORM = {
    uid: null,
    name: "",
    type: "number",
    unit: "",
    value: 0
};

const Form = ({ 
    itemToEdit = null, 
    onFormSubmit, 
    onCancelHandler 
}) => {
    const types = [
        { value: "number", label: "Number" },
        { value: "checkbox", label: "Checkbox" },
    ];

    const checkboxDefaultOptions = [
        { value: "not_checked", label: "Not Checked" },
        { value: "checked", label: "Checked" },
    ];

    const [form, setForm] = useState(DEFAULT_FORM);

    const MAX_LENGTH = 60;

    useEffect(() => {
        if (itemToEdit) {
            setForm({
                uid: itemToEdit.uid,
                name: itemToEdit.name,
                type: itemToEdit.type ?? "number",
                unit: itemToEdit.payload?.unit ?? "",
                value: itemToEdit.payload?.value ?? 0,
            });
        }
    }, [itemToEdit]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        let val = value;

        switch (type) {
            case "checkbox":
                if (checked) {
                    val = 'checked';
                } else {
                    val = 'not_checked';
                }
                break;
        }

        setForm(prevForm => ({
            ...prevForm,
            [name]: val,
        }));
    };

    const handleTypeChange = (selectedOption) => {
        setForm(prevForm => ({
            ...prevForm,
            type: selectedOption.value,
            unit: "",
            value: selectedOption.value === 'checkbox' ? 'not_checked' : 0,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await onFormSubmit({ ...form });
        } catch (error) {
            console.error('Failed to save value:', error);
        }
    };

    const handleCancel = () => {
        setForm(DEFAULT_FORM);
        onCancelHandler();
    };

    return (
        <div className="card container-height">
            <form id="tagsForm" className="d-flex flex-column h-100" onSubmit={handleSubmit}>
                <div className="card-header form-card-header-paddings no-background no-border">
                    <div className="p-2">
                        <h3>{form.uid ? 'Edit Value' : 'New Value'}</h3>
                    </div>
                </div>

                <div className="card-body form-card-body-paddings overflow-auto">
                    <div className="mb-3">
                        <div className="d-flex justify-content-between">
                            <label htmlFor="valueName" className="form-label">Name</label>
                            <small className="text-muted">{form.name.length}/{MAX_LENGTH}</small>
                        </div>
                        <input
                            type="text"
                            id="valueName"
                            name="name"
                            value={form.name}
                            onChange={handleInputChange}
                            className="form-control"
                            maxLength={MAX_LENGTH}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="type" className="form-label">Type</label>
                        <ThemedSelect
                            name="type"
                            options={types}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={types.find(o => o.value === form.type) || null}
                            onChange={handleTypeChange}
                            placeholder="Select type..."
                            isDisabled={itemToEdit ? true : false}
                        />
                    </div>

                    {form.type === 'number' && (
                        <>
                            <div className="mb-3">
                                <label htmlFor="defaultValue" className="form-label">Default Value</label>
                                <input
                                    type="number"
                                    id="defaultValue"
                                    name="value"
                                    value={form.value ?? ''}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Optional"
                                />
                            </div>

                            <div className="mb-3">
                                <div className="d-flex justify-content-between">
                                    <label htmlFor="unitName" className="form-label">Unit Name</label>
                                    <small className="text-muted">{form.unit.length}/{MAX_LENGTH}</small>
                                </div>
                                <input
                                    type="text"
                                    id="unitName"
                                    name="unit"
                                    value={form.unit}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    maxLength={MAX_LENGTH}
                                    placeholder="Optional"
                                />
                            </div>
                        </>
                    )}

                    {form.type === 'checkbox' && (
                        <div className="mb-3">
                            <label htmlFor="defaultValueCheckBox" className="form-label">Default Value</label>
                            <ThemedSelect
                                name="value"
                                options={checkboxDefaultOptions} 
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={checkboxDefaultOptions.find(o => o.value === form.value) || null}
                                onChange={(selectedOption) => { 
                                    setForm(prevForm => ({
                                        ...prevForm,
                                        value: selectedOption.value,
                                    }));
                                }}
                                placeholder="Select default..."
                            />
                        </div>
                    )}
                </div>

                <div className="card-footer form-card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button type="submit" className="btn btn-success">
                            {form.uid ? 'Save' : 'Add'}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Form;